module.exports = __webpack_public_path__ + "media/images/logo-text-white-f705fe10d54eafa50e2c14cd37478118.svg";